﻿/* 
Object:         User Profile (Password change)
Description:    Logic and events for the module User Profile (Password Change)
Used in:        UserProfile
*/

window.passwordchange = function () {

    return {
        /**
        * Init (binding button actions)
        */
        initialize: function (readonly) {

            if (readonly) {
                viewmode.disableAllInputs("ChangePasswordForm");
            }
        },

        /**
        * Checks Passwordfield and Pasword2 field have identical values.
        * Is called on leaving Password2 field.
        * @param { any } DOMelement
        */
        onPassword2Field: function (e) {

            var valNewPw = $("#Password").val();            

            if (e.value != valNewPw) {
                // We could write something in screen
                // $('#Validation').text();
            }
        }
    }    

}();